// SEO indexing scope.
//
// 2026-07-16 → 2026-08-18 we ran a REGIONAL-FOCUS experiment: only PA/NJ/NY/DE stayed indexable,
// every other state's city×service page was served `noindex, follow` and dropped from the sitemap,
// the idea being to concentrate authority instead of diluting it across ~40k near-duplicate pages.
//
// VERDICT (measured, Paul's call 2026-08-18): it did not pay. Clicks fell from ~100/week to ~28/week
// and daily visits halved, while the zone pages never took off — a young domain has too little
// authority for "concentration" to produce anything. The out-of-zone clicks never converted either,
// so nothing was lost commercially — but nothing was gained, and the reach was. We reopen nationwide:
// visibility everywhere also builds brand awareness, which is what an early-stage marketplace needs.
//
// HOW TO USE
//   NATIONWIDE (current): leave SEO_INDEX_STATES empty → every state is indexable.
//   RESTRICTED: put 2-letter uppercase state codes in the set → only those stay indexable.
export const SEO_INDEX_STATES = new Set([]);

// True when the state may be indexed. An EMPTY set means "no restriction — index everything",
// which is why this cannot simply be `SEO_INDEX_STATES.has(...)`.
export function isSeoIndexState(stateCode) {
  if (SEO_INDEX_STATES.size === 0) return true;
  return SEO_INDEX_STATES.has(String(stateCode || '').toUpperCase());
}
